import {ContextAction} from '@ELib/functions/contextMenu';

/** Abstraction of a type that is either a promise that resolves to a value, or the value itself. */
export type Awaitable<T> = T | PromiseLike<T>;
export type ArrayElement<T> = T extends (infer U)[] ? U : never;

export type SetInactiveTextType = (text: string) => void;

export type Action<T extends object> = {
  id: string;
  callback?: (arg0: T) => void | Promise<void | boolean>;
  inactive?: boolean | ((selectedItems: T) => boolean);
  inactiveAsync?: (setInactiveText: SetInactiveTextType) => Promise<boolean>;
  inactiveText?: string;
  subActions?: ContextAction<T>[];
  text: string | ((selectedItems: T) => string);
  keepsOpen?: boolean;
  section?: number;
  Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  type?: ShortKeyActionType;
};

export enum ShortKeyActionType {
  DOUBLE_CLICK = 'DoubleClick',
  DELETE = 'ActionDelete',
}

export enum LoginSessionType {
  BROWSER = 'default-application',
}

export enum Positioning {
  TopLeftAlignDown,
  BottomLeftAlignDown,
  BottomRightAlignDown,
  TopRightAlignDown,
  TopRightOutsetDown,
  TopLeftOutsetDown,
}

export enum Placement {
  TopLeft,
  TopCenter,
  InnerTopCenter,
  TopRight,
  BottomLeft,
  BottomCenter,
  InnerBottomCenter,
  BottomRight,
  LeftTop,
  LeftCenter,
  InnerLeftCenter,
  LeftBottom,
  RightTop,
  RightCenter,
  InnerRightCenter,
  RightBottom,
  TopLeftInnerCorner,
  TopRightInnerCorner,
  BottomLeftInnerCorner,
  BottomRightInnerCorner,
  TopLeftOuterCorner,
  TopRightOuterCorner,
  BottomLeftOuterCorner,
  BottomRightOuterCorner,
}

export enum OSTypes {
  macOS,
  iOS,
  Windows,
  Android,
  Linux,
}

export enum PasswordValidityState {
  NONE = 'none',
  INVALID = 'invalid',
  LOADING = 'loading',
  VALID = 'valid',
}

/**
 * Type definition of the dataTransfer object of the drag event.
 * @example
 * {format: 'lexian-document-id', data: document.id}
 *
 * @property {string} format - defines the type of the data
 * @property {string} data - an identifier to uniquely identify the drag element
 */
export type EDragData = {format: string; data: string};

export enum Order {
  Ascending = 'ASC',
  Descending = 'DESC',
}
